import { useMutation } from 'react-query';
import restFactory from 'v2/utils/restFactory';

async function validateStrapiUserEmail(email: string) {
  return await restFactory.post<undefined>(
    '/dj/api/v1/strapi_user/email_validity_checks/',
    {
      email,
    }
  );
}

export function useStrapiUserEmailValidation() {
  return useMutation<undefined, string, string>({
    mutationFn: validateStrapiUserEmail,
  });
}
